export const LOADING = 'APP/LOADING';
export const CREATE_TODO_ITEM = 'TODO/CREATE_TODO_ITEM';
export const DELETE_TODO_ITEM = 'TODO/DELETE_TODO_ITEM';
export const CHANGE_TODO_ITEM_CHECKBOX = 'TODO/CHANGE_TODO_ITEM_CHECKBOX';
